import React, {Component} from 'react';
import {SortableContainer} from 'react-sortable-hoc';
import SortableCondition from './SortableCondition';

class SortableRulesContainer extends Component {
    render() {

        if(this.props.items) {
            return (
                <div>
                    {this.props.items.map((condition, i) => {
                        let onlyShowTie = false;
                        let showThen = false;

                        if (condition.subjects.length == 1 && condition.subjects[0].condition == "tie") {
                            onlyShowTie = true;

                        } else if (condition.subjects.length === 1 && condition.subjects[0].condition == "score") {
                            showThen = true;
                        } else if (condition.subjects.length > 1) {
                            if (
                                condition.subjects[condition.subjects.length - 1].condition === "tie" && condition.subjects[condition.subjects.length - 2].condition !== "tie"
                            ) {
                                onlyShowTie = true;
                            } else {
                                showThen = true;
                            }
                        }

                        return (

                            <SortableCondition
                                index={i}
                                key={i}
                                number={i}
                                onlyShowTie={onlyShowTie}
                                showThen={showThen}
                                condition={condition}
                                addCondition={this.props.addCondition}
                                removeRule={this.props.removeRule}
                                removeCondition={this.props.removeCondition}
                                setConditionOperator={this.props.setConditionOperator}
                                setConditionValue={this.props.setConditionValue}
                                setConditionConnector={this.props.setConditionConnector}
                                setConditionResult={this.props.setConditionResult}
                                updateConditionSubject={this.props.updateConditionSubject}
                                renderSubjectSelect={this.props.renderSubjectSelect}

                            />

                        )

                    })}
                </div>
            )
        }

    }

}

export default SortableContainer(SortableRulesContainer);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableRulesContainer.js